module.exports = __webpack_public_path__ + "img/reset.14e6a63d.jpg";